import { Box, Button, Typography } from '@mui/material';
import { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import createCache from "@emotion/cache";
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import Switch from "@mui/material/Switch";
import SingInForum from "./SingInForum/SingInForum"
import {
  getforumtokenApi
} from "../services/authApi";
import { customToastify, checkErrorMessage, checkResponseData } from "../components/pages/utils/utilsFunctions"


const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));


const ForumLogin = () => {
  const [lighteMode, setLightMode] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [userInfo, setUserInfo] = useState([""]);
  const controlThemeMode = () => {
    setLightMode(!lighteMode)
    localStorage.setItem("themeMode", !lighteMode);
  }

  const handleShowLoginForm = (value) => {
    setShowLoginForm(value)
  }
  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }


  const getUserInfo = async () => {
    try {
      let response = await getforumtokenApi()
      const resData = checkResponseData(response);
      if (resData["success"]) {
        handleShowLoginForm(true)
        window.location.replace("https://forum.umlang.com")
      } else {
        handleShowLoginForm(false)
        customToastify("info", resData["message"], 3000, "top-center");
        localStorage.removeItem("token")
      }
    } catch (error) {
      // console.log("1111")
      // handleResult("ErrorLoadData")
      // console.log("error")
    }
  }


  const CheckUserSignIn = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        await getUserInfo()
      } else {
        handleShowLoginForm(false)
      }
    } catch (error) {
      localStorage.removeItem("token")
      // handleResult("registerPage")
    }

  }

  useEffect(() => {
    CheckInitialMode();
    CheckUserSignIn();
  }, []);

  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              minHeight: '100vh',
              backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
            }}
          >
            {showLoginForm ? <Typography sx={{ textAlign: "center" }}>
              ورود با موفقیت انجام شد در حال انتقال به انجمن ...
              <br />
              <a href='https://forum.umlang.com' >رفتن به انجمن</a>
            </Typography> : <SingInForum handleShowLoginForm={handleShowLoginForm} />}
          </Box>
        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default ForumLogin;
